import reducer from "./reducers";

import * as confirmadasOps from "./operations";
import * as confirmadasTypes from "./types";
import * as confirmadasSelectores from "./selectores";

export { confirmadasOps, confirmadasTypes, confirmadasSelectores };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/confirmadas/index.js